<template>
  <div
      v-if="showLoader"
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
  >
    <div
        class="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-yellow-500"
    ></div>
  </div>
  <div v-else class="flex justify-between">
    <div class="tabs flex border-b mb-4">
      <button
          class="px-4 py-2 -mb-px font-semibold border-b-4"
          :class="{
          'border-custom-yellow text-custom-blue':
            currentTab === 'ListSchemesTab',
          'text-gray-500': currentTab !== 'ListSchemesTab',
        }"
          @click="currentTab = 'ListSchemesTab'"
      >
        Facility Schemes
      </button>
    </div>

    <div class="flex items-center space-x-4 mt-4 sm:mt-0">
        <CustomButton
            label="Add Facility Scheme"
            :icon-path="'M5 12h14m-7 7V5'"
            bg-class="bg-custom-yellow"
            @click="createScheme"
        />
    </div>
  </div>

  <div class="flex flex-col">
    <ListSchemesTab :fetch="fetch"/>
  </div>

  <CreateSchemeModal :show="showCreateSchemeModal" @close="showCreateSchemeModal = false" @fetch="toggleFetch"/>

</template>


<script setup>
import { ref } from 'vue';
import ListSchemesTab from "@/views/tabs/insurance-tabs/scheme-managment/ListSchemesTab.vue";
import CustomButton from "@/components/CustomButton.vue";
import CreateSchemeModal from "@/views/modals/insurance-management/scheme-management/CreateSchemeModal.vue";


const currentTab = ref('ListSchemesTab');
const fetch = ref(false);
const showCreateSchemeModal = ref(false);

const toggleFetch = () => {
  fetch.value = !fetch.value;
};

const createScheme = () => {
  showCreateSchemeModal.value = true;
}
</script>
<style scoped>

</style>